import { __decorate, __metadata, __param } from 'tslib';
import { EventEmitter, Input, Output, HostListener, Directive, Inject, PLATFORM_ID, ElementRef, NgZone, NgModule } from '@angular/core';
import { CountUp } from 'countup.js';
import { isPlatformBrowser } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
let CountUpDirective = class CountUpDirective {
    constructor(el, zone, platformId) {
        this.el = el;
        this.zone = zone;
        this.platformId = platformId;
        this.options = {};
        this.reanimateOnClick = true;
        this.complete = new EventEmitter();
    }
    // Re-animate if preference is set.
    onClick() {
        if (this.reanimateOnClick) {
            this.animate();
        }
    }
    ngOnChanges(changes) {
        // don't animate server-side (universal)
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        if (changes.endVal && changes.endVal.currentValue !== undefined) {
            if (this.previousEndVal !== undefined) {
                this.options = Object.assign({}, this.options, { startVal: this.previousEndVal });
            }
            this.countUp = new CountUp(this.el.nativeElement, this.endVal, this.options);
            this.animate();
            this.previousEndVal = this.endVal;
        }
    }
    animate() {
        this.zone.runOutsideAngular(() => {
            this.countUp.reset();
            this.countUp.start(() => {
                this.zone.run(() => {
                    this.complete.emit();
                });
            });
        });
    }
};
CountUpDirective.ɵfac = function CountUpDirective_Factory(t) { return new (t || CountUpDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
CountUpDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CountUpDirective, selectors: [["", "countUp", ""]], hostBindings: function CountUpDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CountUpDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { options: "options", reanimateOnClick: "reanimateOnClick", endVal: ["countUp", "endVal"] }, outputs: { complete: "complete" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
__decorate([
    Input('countUp'),
    __metadata("design:type", Number)
], CountUpDirective.prototype, "endVal", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CountUpDirective.prototype, "options", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CountUpDirective.prototype, "reanimateOnClick", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], CountUpDirective.prototype, "complete", void 0);
__decorate([
    HostListener('click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CountUpDirective.prototype, "onClick", null);
CountUpDirective = __decorate([ __param(2, Inject(PLATFORM_ID)),
    __metadata("design:paramtypes", [ElementRef,
        NgZone,
        Object])
], CountUpDirective);

let CountUpModule = class CountUpModule {
};
CountUpModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CountUpModule });
CountUpModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CountUpModule_Factory(t) { return new (t || CountUpModule)(); }, imports: [[]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CountUpDirective, [{
        type: Directive,
        args: [{
                selector: '[countUp]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { options: [{
            type: Input
        }], reanimateOnClick: [{
            type: Input
        }], complete: [{
            type: Output
        }], 
    // Re-animate if preference is set.
    onClick: [{
            type: HostListener,
            args: ['click']
        }], endVal: [{
            type: Input,
            args: ['countUp']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CountUpModule, { declarations: [CountUpDirective], exports: [CountUpDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CountUpModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [CountUpDirective],
                exports: [CountUpDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of count-up
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CountUpModule, CountUpDirective as ɵa };

//# sourceMappingURL=countup.js-angular2.js.map